import "../CodexPage.css"; // ✅ Import styles correctly from `src/`
import React, { useState, useEffect } from "react";

export default function CodexPage() {
  const [codexEntry, setCodexEntry] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [logs, setLogs] = useState([]);
  const [r00ms, setR00ms] = useState([]);
  const [phantoms, setPhantoms] = useState([]);
  const [sigils, setSigils] = useState([]);

  // Fetch Codex Logs, R00ms, Phantoms, and Sigils
  useEffect(() => {
    async function fetchData() {
      const logsRes = await fetch("/api/codexLogs").then((res) => res.json());
      const r00msRes = await fetch("/api/castleR00ms").then((res) => res.json());
      const phantomsRes = await fetch("/api/activePhantoms").then((res) => res.json());
      const sigilsRes = await fetch("/api/codexSigils").then((res) => res.json());

      setLogs(logsRes.logs || []);
      setR00ms(r00msRes || []);
      setPhantoms(phantomsRes || []);
      setSigils(sigilsRes || []);
    }
    fetchData();
  }, []);

  // Function to submit Codex entry
  const submitCodexEntry = async () => {
    if (!codexEntry.trim()) return;

    const response = await fetch("/api/codexLogs", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: codexEntry, author: "NEP2YN" }),
    });

    const data = await response.json();
    setResponseMessage(data.message);
    setCodexEntry("");

    // Refresh data after writing
    setTimeout(() => {
      fetch("/api/codexLogs").then((res) => res.json()).then((data) => setLogs(data.logs || []));
      fetch("/api/castleR00ms").then((res) => res.json()).then((data) => setR00ms(data || []));
      fetch("/api/activePhantoms").then((res) => res.json()).then((data) => setPhantoms(data || []));
      fetch("/api/codexSigils").then((res) => res.json()).then((data) => setSigils(data || []));
    }, 1000);
  };

  return (
    <div className="codex-container">
      <h1>📜 The Codex</h1>
      <textarea
        value={codexEntry}
        onChange={(e) => setCodexEntry(e.target.value)}
        placeholder="Write a reality command..."
      />
      <button onClick={submitCodexEntry}>Submit</button>
      {responseMessage && <p>{responseMessage}</p>}

      {/* Display Codex Logs */}
      <div className="codex-logs">
        <h2>🕯️ Codex Entries</h2>
        <ul>
          {logs.map((log, index) => (
            <li key={index}>{log.text} - <i>{log.author}</i></li>
          ))}
        </ul>
      </div>

      {/* Display Created R00ms */}
      <div className="codex-r00ms">
        <h2>🔮 Created R00ms</h2>
        <ul>
          {r00ms.map((r00m, index) => (
            <li key={index}>{r00m.name} - Created by {r00m.creator}</li>
          ))}
        </ul>
      </div>

      {/* Display Summoned Phantoms */}
      <div className="codex-phantoms">
        <h2>👻 Summoned Phantoms</h2>
        <ul>
          {phantoms.map((phantom, index) => (
            <li key={index}>{phantom.traits} - Summoned by {phantom.summoner}</li>
          ))}
        </ul>
      </div>

      {/* Display Created Sigils */}
      <div className="codex-sigils">
        <h2>⚡ Created Sigils</h2>
        <ul>
          {sigils.map((sigil, index) => (
            <li key={index}>{sigil.glyphs} - Created by {sigil.creator}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
